<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from './form';
import {
  clickVisible,
  operateBlackUser,
} from './actions';

export default {
  name: 'RiskBlackUserList',
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('main_list');
  },
  methods: {
    isExtendsFn(item) {
      const code = item && (item.code || item.buttonCode);
      if (['add', 'edit', 'enable', 'disable'].includes(code)) return false;
      return TablePage.methods.isExtendsFn.call(this, item);
    },

    modalClick({ val, row }) {
      const code = val && (val.code || val.buttonCode);
      if (code === 'add' || code === 'edit') {
        this.formName = 'Form';
        this.formConfig = {
          ...this.formConfig,
          code,
          row: code === 'edit' ? (row || {}) : {},
          formFunctionCode: val.doCode || val.formFunctionCode || 'risk_black_user_form',
        };
        this.modalConfig = {
          ...this.modalConfig,
          title: val.name || val.buttonName || (code === 'edit' ? '编辑黑名单用户' : '新增黑名单用户'),
          showFooter: false,
          footerType: '',
        };
        this.openFull();
        return;
      }

      if (code === 'enable' || code === 'disable') {
        return this.operationClick(code, row);
      }
      return undefined;
    },

    operationClick(code, row) {
      return operateBlackUser({
        code,
        row,
        selection: this.selection,
        request,
        onEmpty: () => this.$message({ type: 'error', message: '请选择数据' }),
        onSuccess: () => {
          this.$message({
            type: 'success',
            message: `${code === 'enable' ? '启用' : '禁用'}成功`,
          });
          this.selection = [];
          this.selectRow = [];
          this.getList();
        },
      });
    },

    deleteClick({ val, row }) {
      const ids = row && row.id !== undefined && row.id !== null
        ? [row.id]
        : this.selection.filter((id) => id !== undefined && id !== null);
      if (!ids.length) {
        this.$message({ type: 'error', message: '请选择数据' });
        return false;
      }

      return this.$confirm(
        (val && val.ask) || '确认删除选中的黑名单用户吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      ).then(() => operateBlackUser({
        code: 'delete',
        row,
        selection: ids,
        request,
        onSuccess: () => {
          this.$message({ type: 'success', message: '删除成功' });
          this.selection = [];
          this.selectRow = [];
          this.getList();
        },
      })).catch(() => undefined);
    },

    clickVisible,
  },
};
</script>
